import { GBIcon, LTIcon } from '@gurupay/gp-ui-library';
import { triggerGAEvent } from '@utils/useGAEvent.ts';
import type { i18n as I18n } from 'i18next';
import { createElement } from 'react';

export const LANGUAGE_OPTIONS = [
	{ label: 'English', value: 'en', icon: createElement(GBIcon) },
	{ label: 'Lietuvių', value: 'lt', icon: createElement(LTIcon) },
];

export const changeAppLanguage = (i18n: I18n, language: string) => {
	i18n.changeLanguage(language);

	if (language === 'lt') {
		triggerGAEvent('language_selected', { language: 'lt' });
	}
};
